module.exports = __webpack_public_path__ + "img/state1.5b075c18.png";